import React, { useContext, useState } from "react";
import { Grid } from "@leap4/frontend";
import SellersDataGrid from "./sellersDataGrid";
import { pick } from 'lodash';
import ReactJsonViewCompare from 'react-json-view-compare';
import { SellerContext } from "./sellerContext";
import SellerPageHeader from "./sellerPageHeader";
import { filterCreatedSellers, prepareSellersForOutput } from "./funcions";
import './customCollapseStyles.css';

const SellerChanges: React.FC = () => {
    const {
        currentSeller,
        chosenSeller,
        setChosenSeller,
        setCurrentSeller,
        site,
    } = useContext(SellerContext);

    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
        setIsCollapsed((prev) => !prev);
    };

    if(!currentSeller || !currentSeller.sellers ) {
        if(currentSeller?.isValidate === false) {
            return (
                <Grid item xs={0} textAlign="left">
                    <div>There is an error on the seller file! <br/> please fix the file on the site and click on the
                        rescrape button.
                    </div>
                    <h2>{currentSeller?.validation_errors}</h2>
                </Grid>
            );
        }
        return null
    }

    // Transform sellers arrays into objects keyed by seller_id
    const currentSellerForCompare = {
        ...currentSeller,
        sellers: Object.fromEntries(
            prepareSellersForOutput(currentSeller).sellers
                .sort((a, b) => Number(a.seller_id) - Number(b.seller_id))
                .map(seller => [seller.seller_id, seller])
        )
    };

    const getSellersArray = (seller) => {
        if (!seller || !seller.sellers) {
            return [];
        }
        return prepareSellersForOutput(seller).sellers || [];
    };

    const chosenSellersArray = getSellersArray(chosenSeller);

    const chosenSellerForCompare = !chosenSeller || !chosenSeller.sellers
        ? currentSellerForCompare
        : {
            ...chosenSeller,
            sellers: Object.fromEntries(
                chosenSellersArray
                    .sort((a, b) => Number(a.seller_id) - Number(b.seller_id))
                    .map((seller) => [seller.seller_id, seller])
            ),
        };

    const sellerParams = ["contact_email", "contact_address", "version", "identifiers", "sellers"];

    return (
        <>
            <SellerPageHeader
                currentSeller={currentSeller}
                siteDomainName={site.domain}
                title={"Sellers.json Changes"}
            />
            <Grid item xs={12}>
                <div className="collapse-header" onClick={toggleCollapse}>
                    <h4 style={{ cursor: 'pointer',textAlign: 'left'}}>
                        {isCollapsed ? 'Show Comparison' : 'Hide Comparison'}
                    </h4>
                </div>
                <div
                    className={`collapse-content ${
                        isCollapsed ? 'collapse-content-inactive collapse-content-hidden' : 'collapse-content-active'
                    }`}
                >
                    {!isCollapsed && (
                        <ReactJsonViewCompare
                            // @ts-ignore
                            oldData={pick(filterCreatedSellers(chosenSellerForCompare), sellerParams)}
                            // @ts-ignore
                            newData={pick(filterCreatedSellers(currentSellerForCompare), sellerParams)}
                        />
                    )}
                </div>
            </Grid>
            <Grid item xs={12}>
                <SellerContext.Provider value={{ chosenSeller, setChosenSeller, currentSeller, setCurrentSeller, site }}>
                    <SellersDataGrid />
                </SellerContext.Provider>
            </Grid>
        </>
    );
};

export default SellerChanges;
